export const LANDING = ''
export const ABOUT_US = 'about'
export const RECAP = 'recap'
export const GAME = 'game/'
  export const TIMMY_SELECT = 'timmy-select'
  export const GAME_WELCOME = 'welcome'
  export const PLOT_CHOICE = 'plot-choice'
  export const ONBOARDING = 'onboarding'
  export const NURTURING = 'nurturing'
  export const TIME_LAPSE = 'time-lapse'
  export const NEW_SPROUT = 'new-sprout'
  export const COLLECT_PLANT = 'collect-plant'
  export const KITCHEN = 'kitchen'
